import { useState } from 'react';
import { cn } from '@/lib/utils';

/** Compact rounded bars; the latest bar is bright blue, the rest muted blue-grey. Hover shows the value. */
export function MiniBars({
  data,
  format,
  height = 56,
  label,
}: {
  data: { key: string; value: number }[];
  format: (n: number) => string;
  height?: number;
  label: string;
}) {
  const [hover, setHover] = useState<number | null>(null);
  const max = Math.max(...data.map((d) => d.value), 0) || 1;
  const shown = hover != null ? data[hover] : null;
  return (
    <div>
      <div
        role="img"
        aria-label={`${label}: ${data.map((d) => `${d.key} ${format(d.value)}`).join(', ')}`}
        className="flex items-end gap-[3px]"
        style={{ height }}
        onMouseLeave={() => setHover(null)}
      >
        {data.map((d, i) => (
          // biome-ignore lint/a11y/noStaticElementInteractions: hover is a visual enhancement; values are in aria-label/title
          <div
            key={d.key}
            onMouseEnter={() => setHover(i)}
            className="flex h-full flex-1 items-end"
            title={`${d.key}: ${format(d.value)}`}
          >
            <div
              className={cn(
                'w-full rounded-t-[3px] rounded-b-[1px] transition-colors',
                i === data.length - 1 ? 'bg-accent' : hover === i ? 'bg-faint' : 'bg-bar',
              )}
              style={{ height: `${Math.max(6, (d.value / max) * 100)}%` }}
            />
          </div>
        ))}
      </div>
      <div className="mt-1 flex h-4 justify-between font-mono text-2xs text-faint">
        <span>{shown ? shown.key : data[0]?.key.slice(5)}</span>
        <span className={cn(shown && 'text-fg-2')}>
          {shown ? format(shown.value) : data[data.length - 1]?.key.slice(5)}
        </span>
      </div>
    </div>
  );
}
